import { computed } from "#imports";
const getTextColor = computed(() => {
  return (el) => {
    while (el) {
      if (el.tagName === "DIV" && el.id.includes("voix-slice")) {
        if (getComputedStyle(el).color) {
          return getComputedStyle(el).color;
        }
      }
      if (el.parentElement) {
        el = el.parentElement;
      } else {
        break;
      }
    }
    return "";
  };
});
const vVoixTextColor = {
  updated(el) {
    el.style.color = getTextColor.value(el);
    setTimeout(() => {
      const textColor = getTextColor.value(el);
      if (textColor && textColor !== "rgba(0, 0, 0, 0)") {
        el.style.color = textColor;
      }
    }, 50);
  }
};
export default vVoixTextColor;
